<div class="d-flex justify-content-center align-items-center" style="height:100vh">
  <div class="card" style="width: 350px;">
    <div class="card-body">
      <h5 class="card-title mb-3">Moderatoren-Login</h5>
      <form (ngSubmit)="submit()">
        <div class="mb-3">
          <label class="form-label" for="login">Adobe Connect Benutzername</label>
          <input type="text" id="login" class="form-control" name="login" [(ngModel)]="login" required autofocus>
        </div>
        <div class="mb-3">
          <label class="form-label" for="password">Passwort</label>
          <input type="password" id="password" class="form-control" name="password" [(ngModel)]="password" required>
        </div>
        <div class="alert alert-danger py-1 px-2" *ngIf="error">{{error}}</div>
        <button type="submit" class="btn btn-primary w-100" [disabled]="isSubmitting">
          {{isSubmitting ? 'Anmelden...' : 'Anmelden'}}
        </button>
      </form>
    </div>
  </div>
</div>
